<template>
    <v-app-bar
            app
            class="gr-menu-top"
            dark
    >
        <v-app-bar-nav-icon
                class="gr-nav-icon"
                aria-label="Obrir el menú"
                @click="changeSidebar(true)"
        />

        <router-link to="/cat" class="gr-brand-link" aria-label="Anar a l'inici">
            <img class="gr-logo" src="@/assets/img/logo-ga-white.svg" alt="Gestoria Riola"/>
            <v-toolbar-title class="gr-brand-title">GESTORIA RIOLA</v-toolbar-title>
        </router-link>

        <v-spacer></v-spacer>

        <v-btn text @click="phoneLink" class="hidden-sm-and-down">
            <v-icon>mdi-phone</v-icon>
            <span class="mr-2">Telèfon</span>
        </v-btn>

        <v-btn text @click="whatsappLink" class="hidden-sm-and-down">
            <v-icon>mdi-whatsapp</v-icon>
            <span class="mr-2">Whatsapp</span>
        </v-btn>

        <v-btn text @click="mailLink" class="hidden-sm-and-down">
            <v-icon>mdi-email-outline</v-icon>
            <span class="mr-2">Correu</span>
        </v-btn>

        <v-btn text @click="mapsLink" class="hidden-sm-and-down">
            <v-icon>mdi-google-maps</v-icon>
            <span class="mr-2">On estem</span>
        </v-btn>

        <v-btn text to="/">
            <v-icon>mdi-web</v-icon>
            <span class="mr-2">ESP / <b>CAT</b></span>
        </v-btn>

    </v-app-bar>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "MenuTop",
        computed: {
            ...mapGetters(['collapseSidebar']),
        },
        methods: {
            changeSidebar(value) {
                this.$store.commit('collapseSidebarHandler', value)
            },
            phoneLink() {
                window.open("tel:+34639086934");
            },
            mailLink() {
                window.open("mailto:riola@gestoriariola.com");
            },
            whatsappLink() {
                window.open("//api.whatsapp.com/send?phone=+34639086934&text=Quiero mas informacion!");
            },
            mapsLink() {
                const mapSection = document.getElementById('on-estem');
                if (mapSection) {
                    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    mapSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
                }
            }
        },
    }
</script>

<style scoped>
  .gr-brand-link {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
  }

  .gr-nav-icon {
    margin-right: 4px;
    flex: 0 0 auto;
  }

  .gr-logo {
    height: 40px;
    width: auto;
    margin-right: 10px;
    flex: 0 0 auto;
  }

  .gr-brand-title {
    font-weight: 700;
    letter-spacing: 0.04em;
    font-size: 1.15rem;
    flex: 0 1 auto;
    overflow: visible;
  }

  /* Móvil: logo más pequeño y sin texto para que no se corte */
  @media (max-width: 600px) {
    .gr-logo {
      height: 32px;
      margin-right: 6px;
    }

    .gr-brand-title {
      font-size: 0.95rem;
      letter-spacing: 0.02em;
    }
  }

  @media (max-width: 380px) {
    .gr-brand-title {
      display: none;
    }
  }
</style>
